import { useMutation, useQueryClient } from '@tanstack/react-query';

import { postCreateNewTag } from '@arrived/api_v2';
import { Tag, TagPostRequest } from '@arrived/models';

import { UseMutationOptions } from '../queries.utils';
import { tagsByCategoryQueryKeyFn, tagsQueryKeyFn } from './tags.keys';

export function usePostCreateNewTagMutation(options?: UseMutationOptions<Tag, TagPostRequest>) {
  const queryClient = useQueryClient();

  return useMutation((tagPostRequest) => postCreateNewTag(tagPostRequest), {
    ...options,
    onSuccess: (data, variables, context) => {
      const { uuid: tagId, category } = data;

      queryClient.invalidateQueries(tagsQueryKeyFn(tagId));

      if (category) {
        queryClient.invalidateQueries(tagsByCategoryQueryKeyFn(category));
      }

      options?.onSuccess?.(data, variables, context);
    },
  });
}
